(() => {
  'use strict';
  const normalize = value => String(value).toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, '').trim();
  const solidHandles = new Set(['blue-skies', 'sunshine', 'sunset']);
  const combinedSizeSlots = new Set(['6-9months', '9-12months']);
  const actualSize = choice => choice.variant.title.replace(/-/g, '–');
  const optionLabel = choice => `${choice.product.title}${choice.combinedSize ? ' — ' + actualSize(choice) : ''}${choice.variant.available ? '' : ' — sold out in this size'}`;
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-gift-products]').textContent);
    const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:data.currency}).format(amount / 100);
    const cards = [...root.querySelectorAll('[data-gift-card]')];
    const form = root.querySelector('[data-gift-form]');
    const add = root.querySelector('[data-gift-add]');
    const error = root.querySelector('[data-gift-error]');
    const success = root.querySelector('[data-gift-success]');
    const message = root.querySelector('[data-gift-message]');
    let busy = false;
    const selections = () => cards.map(card => card._options.get(card.querySelector('select').value));
    const fail = text => { error.textContent = text; error.hidden = false; };
    function refresh() {
      const chosen = selections();
      const count = chosen.filter(Boolean).length;
      root.querySelector('[data-gift-progress]').textContent = `${count} of 3 prints selected`;
      const summary = root.querySelector('[data-gift-summary]');
      summary.replaceChildren();
      cards.forEach((card, index) => {
        const choice = chosen[index];
        card.classList.toggle('is-selected', Boolean(choice));
        const img = card.querySelector('[data-gift-image]');
        card.querySelector('[data-gift-empty]').hidden = Boolean(choice);
        img.hidden = !choice;
        const details = card.querySelector('[data-gift-details]');
        details.hidden = !choice;
        if (choice) {
          img.src = choice.product.image;
          img.alt = `${choice.product.title} jumper in ${actualSize(choice)}`;
          details.href = choice.product.url + '?variant=' + choice.variant.id;
        } else { img.removeAttribute('src'); img.alt = ''; }
        card.querySelector('[data-gift-selection]').textContent = choice ? `${choice.product.title} — ${actualSize(choice)}` : 'No print selected';
        const li = document.createElement('li');
        li.textContent = `${card.dataset.size.replace('-', '–')}: ${choice ? choice.product.title + (choice.combinedSize ? ' (' + actualSize(choice) + ')' : '') : 'Choose a print'}`;
        summary.append(li);
      });
      const estimates = chosen.map((choice, i) => choice ? choice.variant.price : Math.min(...[...cards[i]._options.values()].filter(x=>x.variant.available).map(x=>x.variant.price)));
      const total = estimates.every(Number.isFinite) ? estimates.reduce((a,b)=>a+b,0) : 10800;
      const price = estimates.every(Number.isFinite) ? total - Math.min(...estimates) : 7200;
      const displayPrice = (count < 3 ? 'From ' : '') + money(price);
      root.querySelector('[data-gift-price]').textContent = displayPrice;
      root.querySelector('[data-gift-regular]').textContent = money(total);
      root.querySelector('[data-gift-regular]').hidden = false;
      root.querySelector('[data-gift-total]').textContent = displayPrice;
      add.disabled = busy || count !== 3;
      add.textContent = busy ? 'Adding your gift box…' : count === 3 ? (root.dataset.offerLive === 'true' ? `Add gift box — ${money(price)}` : 'Add gift box to cart') : 'Choose all 3 prints';
    }
    cards.forEach(card => {
      const select = card.querySelector('select');
      const options = new Map();
      select.replaceChildren(new Option('Choose a print', ''));
      data.products.forEach(product => {
        const size = normalize(card.dataset.size);
        const exact = product.variants.find(v=>v.options.some(o=>normalize(o)===size));
        // These three solids use a real 6–12 month variant for either older-age slot.
        const variant = exact || (solidHandles.has(product.handle) && combinedSizeSlots.has(size)
          ? product.variants.find(v=>v.options.some(o=>normalize(o)==='6-12months')) : null);
        if (!variant) return;
        const choice = {product, variant, combinedSize: !exact};
        options.set(String(variant.id), choice);
        const option = new Option(optionLabel(choice), String(variant.id));
        option.disabled = !variant.available;
        select.add(option);
      });
      card._options = options;
      select.disabled = ![...options.values()].some(x=>x.variant.available);
      if (select.disabled) select.options[0].textContent = 'This size is currently sold out';
      select.addEventListener('change',()=>{error.hidden=true;success.hidden=true;refresh();});
    });
    async function cart() {
      const response=await fetch(data.root+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok) throw Error('We could not check your cart. Please try again.');
      return response.json();
    }
    async function reconcile(boxId, chosen) {
      const current=await cart();
      const own=current.items.filter(item=>item.properties && item.properties._gift_box_id===boxId);
      const expected=new Map();
      chosen.forEach(choice=>{const id=String(choice.variant.id);expected.set(id,(expected.get(id)||0)+1);});
      const complete=[...expected].every(([id,quantity])=>own.filter(x=>String(x.variant_id)===id).reduce((n,x)=>n+x.quantity,0)===quantity) && own.reduce((n,x)=>n+x.quantity,0)===chosen.length;
      if (complete) return true;
      if (own.length) {
        const updates=Object.fromEntries(own.map(item=>[item.key,0]));
        const result=await fetch(data.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({updates})});
        if(!result.ok) throw Error('Some gift items may have reached your cart. Please review your cart before adding again.');
      }
      return false;
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const chosen=selections();
      if(chosen.some(x=>!x)) return;
      busy=true;error.hidden=true;success.hidden=true;refresh();
      const boxId=window.crypto && crypto.randomUUID ? crypto.randomUUID() : 'gift-'+Date.now()+'-'+Math.random().toString(36).slice(2);
      let submitted=false;
      try {
        const handles=[...new Set(chosen.map(x=>x.product.handle))];
        const fresh=await Promise.all(handles.map(async handle=>{
          const response=await fetch(data.root+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',cache:'no-store'});
          if(!response.ok) throw Error('We could not check print availability. Please try again.');
          return response.json();
        }));
        let changed=false;
        chosen.forEach(choice=>{
          const latest=fresh.find(p=>p.handle===choice.product.handle).variants.find(v=>String(v.id)===String(choice.variant.id));
          if (!latest || !latest.available) {
            cards.forEach(card=>{
              const select=card.querySelector('select');
              const option=[...select.options].find(x=>x.value===String(choice.variant.id));
              const stored=card._options.get(String(choice.variant.id));
              if(stored)stored.variant.available=false;
              if(option){option.disabled=true;option.textContent=optionLabel(stored || choice);if(select.value===option.value)select.value='';}
            });
            throw Error(`${choice.product.title} is no longer available in ${choice.variant.title}. Please choose another print.`);
          }
          if(choice.variant.price!==latest.price){choice.variant.price=latest.price;changed=true;}
        });
        if(changed){refresh();throw Error('A jumper price has changed. Please review the updated total and add your gift box again.');}
        // Selecting the same 6–12 month solid twice must request two units of its real variant.
        const itemMap=new Map();
        chosen.forEach((choice,index)=>{
          const id=String(choice.variant.id);
          if(itemMap.has(id)){itemMap.get(id).quantity++;return;}
          itemMap.set(id,{id:choice.variant.id,quantity:1,properties:{'Gift box':'Growing Up, Naturally · 3-piece','Gift packaging':'Included',_gift_box_id:boxId,...(index===0&&message.value.trim()?{'Gift message':message.value.trim()}: {})}});
        });
        const items=[...itemMap.values()];
        submitted=true;
        const response=await fetch(data.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items})});
        if(!response.ok){const body=await response.json().catch(()=>({}));throw Error(body.description||'We could not add the complete gift box. Please try again.');}
        success.hidden=false;
        window.location.assign(data.root+'cart');
      } catch(e) {
        if(submitted){
          try{if(await reconcile(boxId,chosen)){window.location.assign(data.root+'cart');return;}}
          catch(recovery){fail(recovery.message);busy=false;refresh();return;}
        }
        fail(e.message || 'We could not add your gift box. Please try again.');
        busy=false;refresh();
      }
    });
    refresh();
  }
  function start(scope=document){scope.querySelectorAll('[data-gift-box-root]').forEach(initialize);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start());else start();
  document.addEventListener('shopify:section:load',event=>start(event.target));
})();
